import BsPageDescription from './index.vue'
export default BsPageDescription